<template>
  <div id="login-container">
    <h2>Login</h2>
    <input type="email" v-model="email" placeholder="Enter your email" required />
    <input type="password" v-model="password" placeholder="Enter your password" required />
    <div class="button-group">
      <button @click="login">Login</button>
      <button @click="register">Register</button>
    </div>
    <div v-if="errorMessage" class="error">{{ errorMessage }}</div>
  </div>
</template>

<script>
import auth0 from "../authService"

export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      errorMessage: ""
    }
  },
  methods: {
    login() {
      if (!this.email || !this.password) {
        this.errorMessage = "Please enter both email and password."
        return
      }

      // Use the resource owner password grant (this requires proper settings in your Auth0 tenant)
      auth0.login(
        {
          realm: "Username-Password-Authentication",
          username: this.email,
          password: this.password,
          scope: "openid profile email"
        },
        (err, authResult) => {
          if (err) {
            this.errorMessage = err.description || err.message
            console.error(err)
            return
          }
          if (authResult && authResult.idTokenPayload) {
            // Save session info in localStorage
            localStorage.setItem("idToken", authResult.idToken)
            const expiresAt = new Date().getTime() + 86400000 // 24 hours
            localStorage.setItem("expiresAt", expiresAt)
            localStorage.setItem("userEmail", authResult.idTokenPayload.email)
            // Notify parent (App.vue) that login was successful.
            this.$emit("login-success", authResult.idTokenPayload)
          }
        }
      )
    },
    register() {
      if (!this.email || !this.password) {
        this.errorMessage = "Please enter both email and password to register."
        return
      }

      auth0.signup(
        {
          connection: "Username-Password-Authentication",
          email: this.email,
          password: this.password
        },
        (err, result) => {
          if (err) {
            this.errorMessage = err.description || err.message
            console.error(err)
          } else {
            alert("Registration successful! Please log in now.")
          }
        }
      )
    }
  }
}
</script>

<style scoped>
#login-container {
  max-width: 400px;
  margin: 100px auto;
  background: #ffffff;
  padding: 20px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  text-align: center;
}
#login-container input {
  width: 80%;
  margin: 10px 0;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 3px;
}
.button-group {
  display: flex;
  justify-content: center;
  gap: 10px;
}
#login-container button {
  padding: 10px 20px;
  background-color: #28a745;
  color: #ffffff;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  font-weight: bold;
}
#login-container button:hover {
  background-color: #218838;
}
.error {
  margin-top: 10px;
  color: #d9534f;
}
</style>